import { render } from "./xfStarDirection.vue?vue&type=template&id=3812f1ca&scoped=true"
import script from "./xfStarDirection.vue?vue&type=script&lang=js"
export * from "./xfStarDirection.vue?vue&type=script&lang=js"

import "./xfStarDirection.vue?vue&type=style&index=0&id=3812f1ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3812f1ca"]])

export default __exports__